import css from "./Switch.module.scss";
import colors from "src/styles/jscolors.module.scss";

export default function Switch({
    isActive = false,
    color = "emerald",
    action,
}) {
    return (
        <div
            className={`${css["container"]} ${isActive ? css["active"] : ""}`}
            style={{
                "--switch-active-color":
                    colors[`${isActive ? color : "gray"}-500`],
            }}
            onClick={action}
        >
            <span className={css.thumb}></span>
        </div>
    );
}
